/*
 * Application Insights JavaScript SDK - Common, 3.3.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_SPLIT = "split"; // Count: 6
export var _DYN_LENGTH = "length"; // Count: 46
export var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
export var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 6
export var _DYN_TO_STRING = "toString"; // Count: 8
export var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
export var _DYN_MESSAGE = "message"; // Count: 5
export var _DYN_COUNT = "count"; // Count: 6
export var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
export var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
export var _DYN_STRINGIFY = "stringify"; // Count: 4
export var _DYN_PATHNAME = "pathname"; // Count: 4
export var _DYN_MATCH = "match"; // Count: 5
export var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns"; // Count: 2
export var _DYN_NAME = "name"; // Count: 10
export var _DYN_EXTENSION_CONFIG = "extensionConfig"; // Count: 4
export var _DYN_PROPERTIES = "properties"; // Count: 10
export var _DYN_MEASUREMENTS = "measurements"; // Count: 9
export var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 4
export var _DYN_TYPE_NAME = "typeName"; // Count: 5
export var _DYN_EXCEPTIONS = "exceptions"; // Count: 5
export var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
export var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
export var _DYN_PARSED_STACK = "parsedStack"; // Count: 6
export var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 5
export var _DYN_ASSEMBLY = "assembly"; // Count: 4
export var _DYN_FILE_NAME = "fileName"; // Count: 9
export var _DYN_LINE = "line"; // Count: 6
export var _DYN_AI_DATA_CONTRACT = "aiDataContract"; // Count: 4
export var _DYN_DURATION = "duration"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map